<template lang="pug">
div
  section.u-mt-md
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10
      .column
        h1 {{ $t(category.name) }}
        p.u-text-lg.books-desc {{ $t(`${category.name}DescSeo`) }}

  section.u-mt-md
    Query.grid(
      :query="require('~/graphql/Book.gql').Books"
      :limit="10"
      :initialValue="books"
      :variables="({ first, after }) => ({ first, after, publishedIn: category.scope })"
    )
      template(slot-scope="{ items }")
        .column.is-desktop-4.is-tablet-6(v-for="book in items" :key="book.id")
          AppCard(:img="book.thumb" :title="book.title" :url="`/books/${book.slug}`" ratio="4:5")

</template>

<style lang="stylus">
.books-desc
  max-width: 820px
</style>

<script>
import { Books } from '~/graphql/Book.gql';
import Query from '~/components/Query';

export default {
  scrollToTop: true,
  meta: {
    logoText: 'books',
    theme: 'books'
  },
  head() {
    return {
      title: this.$t(this.category.name),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t(`${this.category.name}Desc`)
        },
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: this.category.title
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.$t(`${this.category.name}Desc`)
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/share/books.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/share/books.png'
        }
      ]
    };
  },
  components: {
    Query
  },
  async asyncData({ app, params, error }) {
    const categories = {
      design: {
        name: 'design',
        scope: 'DESIGN'
      },
      code: {
        name: 'code',
        scope: 'CODE'
      },
      business: {
        name: 'business',
        scope: 'BIZ'
      },
      culture: {
        name: 'culture',
        scope: 'CULTURE'
      },
      leadership: {
        name: 'leadership',
        scope: 'LEADERSHIP'
      }
    };

    const categoryName = params.pathMatch;

    if (!(categoryName in categories)) {
      return error({
        statusCode: 404,
        message: 'No such category for our books.',
        link: '/books',
        linkDescription: 'Back to our books'
      });
    }

    const category = categories[categoryName];

    const { data } = await app.$api.query({
      query: Books,
      variables: {
        publishedIn: category.scope,
        first: 6
      }
    });

    return {
      ...data,
      category
    };
  }
};
</script>

<i18n>
{
  "en": {
    "design":"Design books",
    "designDesc":"Recharge your creative battery with the essential principles and theories of design in books.",
    "designDescSeo":"Read Baianat design books and discover the latest in the field of design starting from branding to type design and animation.",
    "code":"Code books",
    "codeDesc":"Read more on the latest hacks for both mobile and web development applications.",
    "codeDescSeo":"Read more on programming concepts and discover the latest techniques through Baianat books in both mobile and web development.",
    "business":"Business books",
    "businessDesc":"In depth materials to help businesses and individuals accelerate their processes.",
    "businessDescSeo":"Learn more on the business matter through Baianat business books and stay updated with the latest in the field.",
    "culture":"Culture books",
    "cultureDesc":"Introducing our guiding values, attitudes, beliefs in every aspect of the Baianat.",
    "cultureDescSeo":"Discover Baianat culture through a collection of books that introduces you to our culture, the general guidelines of the place.",
    "technology":"Technology books",
    "technologyDesc":"Discover the more in technology fields through books that tackle everything from the basics to advanced levels.",
    "technologyDescSeo":"Know more about the latest technology trends through Baianat books in the fields of IoT, big data and analytics, robotics and more.",
    "leadership":"Leadership",
    "leadershipDesc":"Discover the more in leadership fields through books that tackle everything from the basics to advanced levels.",
    "leadershipDescSeo":"Know more about the latest leadership trends through Baianat books in the fields of IoT, big data and analytics, robotics and more."
  },
  "ar": {
    "design":"كتب التصميم",
    "designDesc":"أعد شحن بطاريتك الإبداعية من خلال المبادئ الأساسية ونظريات التصميم.",
    "designDescSeo":"تعرف على كل ما يشغل بالك في مجال التصميم من خلال كتب التصميم التي توفرها بيانات بداية من العلامة التجارية والشعارات إلى الخطوط.",
    "code":"البرمجة",
    "codeDesc":"اقرأ المزيد عن أحدث النصائح حول  تطوير الموقع الإلكتروني وتطبيقات الجوال. ",
    "codeDescSeo":"اكتشف أحدث التقنيات البرمجية والأساليب التي يتم اتباعها في برمجة المواقع والتطبيقات من خلال قراءة كتب البرمجة الخاصة ببيانات.",
    "business":"كتب البيزنس",
    "businessDesc":"نساعد الأفراد والشركات على تحسين عملياتهم عبر مواد مكثفة.",
    "businessDescSeo":"اكتشف المزيد من المعلومات حول عالم البيزنس من خلال الكتب التي تقدمها بيانات وكن على اطلاع دائم بما يحدث في المجال. ",
    "culture":"كتب ثقافة بيانات",
    "cultureDesc":"مقدمة للقيم التي نتبناها وتصرفاتنا ومعتقداتنا وكل جانب من جوانب بيانات.",
    "cultureDescSeo":"تعرف على ثقافة بيانات من خلال مجموعة من الكتب التي تحكي من خلالها الثقافة العامة للمكان والمنهجية التي نعمل بها وحياة اللاعبين داخلها.",
    "technology":"كتب التكنولوجيا",
    "technologyDesc":"اكتشف المزيد في مجالات التكنولوجيا من خلال الكتب التي تتناول كل شيء بدءًا من الأساسيات وحتى المستويات المتقدمة.",
    "technologyDescSeo":"اكتشف المزيد من المعلومات حول عالم البيزنس من خلال الكتب التي تقدمها بيانات وكن على اطلاع دائم بما يحدث في المجال. ",
    "leadership":"القيادة",
    "leadershipDesc":"اكتشف المزيد في مجالات القيادة من خلال الكتب التي تتناول كل شيء بدءًا من الأساسيات وحتى المستويات المتقدمة.",
    "leadershipDescSeo":"اكتشف المزيد من المعلومات حول عالم القيادة من خلال الكتب التي تقدمها بيانات وكن على اطلاع دائم بما يحدث في المجال. "
  }
}
</i18n>
